import React from 'react';
import { AcvtSupportedLanguages } from '../../../types/acvt';
import { useT } from '../../preview';
import { AcvtGenHeader } from '../generic-header';
import { AcvtTopTabs } from '../top-tabs';
import { AcvtCouponsPage } from './coupons-page';
import { AcvtInStorePage } from './instore-page';
import style from './style.module.scss';

type AcvtPromotionsPageProps = {
    /**
     * Kept for backward compatibility — strings come from `useT()`.
     */
    language?: AcvtSupportedLanguages;
    offersList?: (string | undefined)[];
    couponCategoriesList?: (string | undefined | null)[];
    inStoreCategoriesList?: (string | undefined | null)[];
    couponCards: JSX.Element;
    inStoreCards: JSX.Element;
    selectedOffer: string | undefined;
    selectedCouponCategory: string | undefined;
    selectedInStoreCategory: string | undefined;
    changeOffers: (selection: string) => void;
    changeCouponCategories: (selection: string) => void;
    changeInStoreCategories: (selection: string) => void;
};

export const AcvtPromotionsPage = (props: AcvtPromotionsPageProps) => {
    const t = useT();
    return (
        <div className={style.promotions_content}>
            <AcvtGenHeader>{t.promotions.title}</AcvtGenHeader>
            <AcvtTopTabs
                tabsArray={[
                    {
                        name: t.promotions.tabCoupons,
                        key: 'coupons',
                        children: (
                            <AcvtCouponsPage
                                cards={props.couponCards}
                                offersList={props.offersList}
                                categoriesList={props.couponCategoriesList}
                                selectedOffer={props.selectedOffer}
                                selectedCategory={props.selectedCouponCategory}
                                changeOffers={props.changeOffers}
                                changeCategories={props.changeCouponCategories}
                            />
                        ),
                    },
                    {
                        name: t.promotions.tabInStore,
                        key: 'instore',
                        children: (
                            <AcvtInStorePage
                                cards={props.inStoreCards}
                                categoriesList={props.inStoreCategoriesList}
                                selectedCategory={props.selectedInStoreCategory}
                                changeCategories={props.changeInStoreCategories}
                            />
                        ),
                    },
                ]}
            />
        </div>
    );
};
